module.exports = __webpack_public_path__ + "img/pinterest-source.9ef50bfb.svg";